<div mat-dialog-content>
    <p>Sub-Admin</p>
    <mat-form-field appearance="fill">
        <mat-label>Password</mat-label>
        <input matInput type="password" [(ngModel)]="password" />
    </mat-form-field>
</div>
<div mat-dialog-actions>
    <button class="btn btn-primary" (click)="btn_updatePassword();">Submit</button>
</div>